import { render, staticRenderFns } from "./Manutenzione.vue?vue&type=template&id=79cac232&"
import script from "./Manutenzione.vue?vue&type=script&lang=js&"
export * from "./Manutenzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports